import React, { useState } from 'react';
import styled from 'styled-components';
import { SEM_COLOR_FORMS_FOREGROUND_ICONS_DEFAULT_LIGHT } from '@oneaudi/unified-web-common';
import { Text, Icon } from '@oneaudi/unified-web-components';
import { StyledImagePlaceholder, StyledImg } from '../styles/ModelFilter.styles';
import { VisuallyHidden } from '../utils/utils';
import { useDesktopOrMobileView } from '../../../hooks';
import { dynamicStylingHelper } from '../../utils';
import { SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK } from '@oneaudi/unified-web-alpha-common';
export const ModelImage = ({ carlineGroup, carlineGroupPhoto, carlineGroupPhotoNotAvailableText, open, }) => {
    const isAtLeastMBreakpoint = useDesktopOrMobileView('768px') === 'desktop';
    const isAtLeastLBreakpoint = useDesktopOrMobileView('1024px') === 'desktop';
    const isAtLeastXLBreakpoint = useDesktopOrMobileView('1440px') === 'desktop';
    let order = '2';
    let iconSize = 's';
    if ((isAtLeastMBreakpoint && !isAtLeastLBreakpoint) || isAtLeastXLBreakpoint) {
        order = '1';
        iconSize = 'l';
    }
    const [imgIsBroken, setImgIsBroken] = useState(false);
    const handleError = () => {
        setImgIsBroken(true);
    };
    if (!carlineGroupPhoto) {
        return (React.createElement(StyledImagePlaceholder, { open: open },
            React.createElement(StyledIcon, { name: "photo-none", size: iconSize }),
            React.createElement(VisuallyHidden, null, carlineGroup),
            React.createElement(Text, { tag: "p", variant: {
                    order,
                    style: 'normal',
                    type: 'copy',
                } }, carlineGroupPhotoNotAvailableText)));
    }
    if (imgIsBroken) {
        return (React.createElement(StyledImagePlaceholder, { open: open },
            React.createElement(StyledIcon, { name: "photo-none", size: iconSize }),
            React.createElement(VisuallyHidden, null, carlineGroup),
            React.createElement(Text, { tag: "p", variant: {
                    order,
                    style: 'normal',
                    type: 'copy',
                } }, carlineGroupPhotoNotAvailableText)));
    }
    return React.createElement(StyledImg, { alt: `${carlineGroup}`, src: `${carlineGroupPhoto}`, onError: handleError });
};
export default ModelImage;
const StyledIcon = styled((props) => React.createElement(Icon, Object.assign({}, props))) `
  padding-bottom: var(--spacing-relative-xs);
  color: ${dynamicStylingHelper(SEM_COLOR_FORMS_FOREGROUND_ICONS_DEFAULT_LIGHT, SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK)};
`;
